export default __webpack_public_path__ + "static/media/HTML5.bf6bb1c2.svg";